import Vue from "vue";
import VueRouter from "vue-router";
import HeiMapPage from "../views/HeiMapPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/map"
  },
  {
    path: "/map",
    name: "Map",
    component: HeiMapPage,
    meta: { transitionName: "slide-right" }
  },
  {
    path: "/table/:state",
    name: "Table",
    props: true,
    component: () => import("../views/HeiTablePage.vue"),
    meta: { transitionName: "slide-left" }
  },
  {
    path: "/sources",
    name: "Sources",
    props: true,
    component: () => import("../views/HeiSourcesPage.vue"),
    meta: { transitionName: "slide-right" }
  }
];

const router = new VueRouter({
  routes
});

export default router;
